export const foodSciencesData = {
    departmentName: "Department of Food Science and Nutrition",
    bannerImage: "/infrastructure/foodsciences/lab-1.JPG",

    about: {
        title: "About the Department",
        content: `The Food Science and Nutrition programme at Rayalaseema University focuses on the scientific study of food, nutrients, and their impact on human health. The programme integrates principles of food chemistry, food processing, nutrition, and public health to develop skilled professionals capable of addressing nutritional challenges, food safety, and quality assurance. Emphasis is placed on both theoretical knowledge and practical applications to promote health, wellness, and sustainable food systems.`,
        highlights: [
            "Well-equipped laboratories for food analysis and nutritional assessment",
            "Advanced facilities for food processing, preservation, and quality control",
            "Focus on human nutrition, dietetics, and public health nutrition",
            "Research and practical training in food safety and quality assurance",
            "Community outreach programs on nutrition awareness and healthy lifestyles"
        ]

    },

    brochure: {
        title: "Department Brochure",
        pdfLink: "/botany/department-brochure.pdf",
        description: "Download our comprehensive department brochure for detailed information."
    },

    hod: {
      id: "bio001",
      name: "Dr.G.V.Swarnalatha",
      designation: "Co-ordinator,Assistant Professor(C)",
      email: "venkata85722@gmail.com",
      mobile: "+91 8639514999",
      photo: "/biotechnology/Dr.Swarnalatha.JPG",
      qualification: "M.Sc., Ph.D.,CSIR-NET",
      specialization: "Algal Biochemistry",
      profileLink: "/biotechnology/Dr.Swarnalatha.pdf",
        // name: "Dr. Bharath Kumar Ravuru",
        // designation: "Professor & Head",
        // photo: "/botany/bharath.JPG",
        // email: "drbharathravuru@gmail.com",
        // mobile: "8500722075",
        // qualification: "M.Sc., Ph.D.",
        // specialization: "Plant Biotechnology, Ethnobotany &  Forest Ecology ",
        message: `Welcome to the Department of Botany at Rayalaseema University. We are committed to excellence in 
    botanical education and research. Our department provides a stimulating environment for students to explore the 
    fascinating world of plants and their applications. We encourage innovation in plant sciences and emphasize the 
    importance of plant conservation for sustainable development.`,
        // profileLink: "/botany/bharath.pdf"
    },

    bos: {
  title: "Food Science & Nutrition",
  members: [
    {
      name: "Prof. R. Bharath Kumar",
      designation: "Chairperson",
      affiliation: "Dept. of Botany, School of Life Sciences, Rayalaseema University, Kurnool"
    },
    {
      name: "Dr. Giridhar Parvatam",
      designation: "Member",
      affiliation: "Director, CSIR-CFTRI, Ministry of Science & Technology, Govt. of India, Mysuru"
    },
    {
      name: "Prof. Riazunnisa",
      designation: "Member",
      affiliation: "Dept. of Food Technology, Yogi Vemana University, Kadapa"
    },
    {
      name: "Dr. V. Rama Krishna",
      designation: "Member",
      affiliation: "Associate Professor, Dept. of Biotechnology & Bioinformatics, Yogi Vemana University"
    },
    {
      name: "Prof. M. Aruna",
      designation: "Member",
      affiliation: "Department of Home Sciences, Sri Padmavathi Mahila Viswavidyalayam (SPMVV), Tirupati"
    },
    {
      name: "Dr. K. V. Sucharitha",
      designation: "Member",
      affiliation: "Professor, Department of Home Sciences, Sri Venkateswara University, Tirupati"
    },
    {
      name: "Dr. Tamatam Anand",
      designation: "Member",
      affiliation: "Scientist F & HOD, Defense Food Research Laboratory, Mysore"
    },
    {
      name: "Prof. M. Sardar Baig",
      designation: "Member",
      affiliation: "College of Food Science & Technology, ANGRAU, Pulivendula, YSR District"
    }
  ]
}
,

    faculty: [
    //    {
    //   id: "bio001",
    //   name: "Dr.G.V.Swarnalatha",
    //   designation: "Co-ordinator,Assistant Professor(C)",
    //   email: "venkata85722@gmail.com",
    //   mobile: "+91 8639514999",
    //   photo: "/biotechnology/Dr.Swarnalatha.JPG",
    //   qualification: "M.Sc., Ph.D.,CSIR-NET",
    //   specialization: "Algal Biochemistry",
    //   profileLink: "/biotechnology/Dr.Swarnalatha.pdf"
    // },
        // {
        //     name: "Dr. Bharath Kumar Ravuru",
        //     designation: "Professor & Head",
        //     email: "drbharathravuru@gmail.com",
        //     mobile: "8500722075",
        //     photo: "/botany/bharath.JPG",
        //     qualification: "M.Sc., Ph.D.",
        //     specialization: "Plant Biotechnology, Ethnobotany &  Forest Ecology",
        //     profileLink: "/botany/bharath.pdf"
        // },
        // {
        //     name: "Dr. G. Sri Ranganayakulu",
        //     designation: "Assistant Professor (MTS)",
        //     email: "gsranganaayakulu@gmail.com",
        //     mobile: "9989239242",
        //     photo: "/botany/ranga.JPG",
        //     qualification: "M.Sc., Ph.D.",
        //     specialization: "Plant Physiology and Molecular Biology ",
        //     profileLink: "/botany/ranga.pdf"
        // },
        // {
        //     name: "Dr. K. Venkata Ratnam",
        //     designation: "Assistant Professor (C)",
        //     email: "drvenkatapkd@gmail.com",
        //     mobile: "8008497926",
        //     photo: "/botany/venkataramanabotony.JPG",
        //     qualification: "M.Sc.,M.Phil, Ph.D.",
        //     specialization: "Ethnobotany, Plant Taxonomy, Microbiology, Animal Tissue Culture",
        //     profileLink: "/botany/VENKATA.pdf"
        // },
        // {
        //     name: "Dr. Kavitha Bommana",
        //     designation: "Assistant Professor (C)",
        //     email: "kavithab15@Gmail.com",
        //     mobile: "9290755720",
        //     photo: "/botany/kavitha.JPG",
        //     qualification: "M.Sc., M.Phil, Ph.D.",
        //     specialization: "Phytomedicine & Pharmacognostic Studies of Herbal drugs ",
        //     profileLink: "/botany/KAVITHA.pdf"
        // }
    ],

    courses: {
        // undergraduate: [
        //     {
        //         name: "B.Sc. Horticulure",
        //         duration: "3 Years",
        //         eligibility: "10+2 with Biology",
        //         intake: "60 seats"
        //     }
        // ],
        postgraduate: [
            {
                name: "M.Sc. Food Science and Nutrition",
                duration: "2 Years",
                eligibility: "B.Sc. with BotanyB.Sc. Home Science, B.Sc. Food Science and Nutrition, B.Sc. Nutrition and Dietetics, B.Sc. Foods and Nutrition",
                intake: "30 seats"
            }
        ],
        // research: [
        //     {
        //         name: "Ph.D. in Botany",
        //         duration: "Minimum 3 Years",
        //         eligibility: "M.Sc. Botany",
        //         areas: "Plant Biotechnology, Ethnobotany &  Forest Ecology "
        //     }
        // ]
    },

    Infrastructure: [
    
        "/infrastructure/foodsciences/lab-1.JPG",
        "/infrastructure/foodsciences/lab-4.JPG",
        "/infrastructure/foodsciences/lab-2.JPG",
        "/infrastructure/foodsciences/lab-3.JPG",
        "/infrastructure/foodsciences/lab-5.JPG",
        "/infrastructure/foodsciences/lab-6.JPG",
       
    ]
};
